/**
 * @typedef {Object} columnInterface
 * @property {string} component
 * @property {Function} format
 * @property {Function} icon
 * @property {boolean} primary
 * @property {boolean} grid
 * @property {boolean} sidebar
 * @property {Object} form
 */

/**
 * @param {columnInterface} data
 */
export default (data) => ({
  component: 'value-formatted',
  format: (item, name) => item[name] || '-',
  icon: (item) => null,
  primary: false,
  grid: true,
  sidebar: true,
  form: null,
  ...data,
});
